import script from "./FileBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileBlock.vue?vue&type=script&setup=true&lang=ts"

import "./FileBlock.vue?vue&type=style&index=0&id=46ecd45f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46ecd45f"]])

export default __exports__